import * as React from 'react';
import { IMedia, IGenre, IPerson, ICity } from '../../interfaces';
import Favorite from '../parts/Favorite';
import { NavLink } from 'react-router-dom';
import { transliterate } from '../../utils/functions';

interface IProps {
    slide: IMedia,
}

export default class Trailer extends React.Component<IProps, any>{

    render() {
        let { slide } = this.props;

        return (
            <div className="item">
                <div className="img img_box">

                    <a href="#!"> <img src={slide.fullFirstFrame} /> </a>

                    <div className="icons">
                        <ul>
                            <li>
                                <Favorite media={slide} />
                            </li>
                            <li className="transform">
                                <NavLink className="scroll-to-top" to={`/film/${transliterate(slide.leftName)}/${slide.media_id}`}>
                                    <i className="fa fa-play-circle-o"></i>
                                </NavLink>
                            </li>
                            <li className="btn-group share-box">
                                <button type="button" className="btn btn-default dropdown-toggle"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i className="fa fa-ellipsis-h"></i>
                                </button>
                            </li>
                        </ul>
                    </div>

                </div>

                <h1 className="text-center"> <NavLink to={`/film/${transliterate(slide.leftName)}/${slide.media_id}`} title={slide.leftName}> {slide.leftName} </NavLink> </h1>

            </div>

        );
    }
}